<div class="mbuilder-main-container">
   <nav aria-label="breadcrumb">
        <ol class="breadcrumb builder-breadcrumb">
                  <li (click)="onClickBreadcrumb('home')" class="breadcrumb-item inactive">Home</li>
                  <li (click)="onClickBreadcrumb('projId')" class="breadcrumb-item inactive">
                      {{this.breadcrumbData?.projectName | titlecase}}
                  </li>
              <li class="breadcrumb-item active">{{this.breadcrumbData?.webApplicationName }}</li>
        </ol>
    </nav>
   
    <div class="mbuilder-body">
        <div class="mbuilder-sidenav">
            <lib-web-sidenav></lib-web-sidenav>
            <div class="mbuilder-sidenav-options">
                <div class="option"  *ngIf="displaySidenavContent" @sidenavFadInOut [ngClass]="{'custom-width': isWidthApplied}">
                    <div class="option-item">
                        <lib-web-sidenav-content></lib-web-sidenav-content>
                    </div>
                    <div class="option" *ngIf="displaySidenavContentList" @sidenavFadInOut > 
                        <div class="option-item" >
                            <lib-web-sidenav-content-list></lib-web-sidenav-content-list>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="mbuilder-canvas" [ngClass]="{ 'mbuilder-level-one': displaySidenavContent, 'mbuilder-level-two': displaySidenavContentList && displaySidenavContent }" *ngIf="!apiTab">
            <lib-web-screen class="d-block m-4" ></lib-web-screen>
        </div>
        <div class="mapi-canvas" *ngIf="apiTab"
        [ngClass]="{ 'mbuilder-level-one': displaySidenavContent, 'mbuilder-level-two': displaySidenavContentList && displaySidenavContent }">
        <lib-apiconfig></lib-apiconfig>
    </div>

    </div>
</div>